import React from 'react';
import ReactDOM from 'react-dom/client';
// import App from './App';
import Root from "./Root";

const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <App />
// );
root.render(
    <React.StrictMode>
        <Root />
    </React.StrictMode>
);
